import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useStorageKeys } from '../../storage';
import { useGrippContext } from '../../grippContext';
import {
  currentWorkspaceQueryKey,
  fetchStoredCurrentWorkspace,
} from './useCurrentWorkspace';

export const useSetCurrentWorkspace = () => {
  const queryClient = useQueryClient();
  const { storageHandler } = useGrippContext();
  const storageKeys = useStorageKeys();
  return useMutation({
    mutationKey: ['currentWorkspace'],
    // Writes device storage only. The default ('online') pauses a mutation
    // while react-query believes the device is offline, which would stall
    // workspace switching and sign-out without ever touching the network.
    networkMode: 'always',
    mutationFn: async (workspace?: string) => {
      if (!workspace) {
        await storageHandler.deleteItem(storageKeys.workspace);
      } else {
        await storageHandler.setItem(storageKeys.workspace, workspace);
      }
    },
    // Set the stored value directly rather than invalidating: a refetch of an
    // online-mode currentWorkspace observer pauses while the device is offline,
    // and mutateAsync would wait on it.
    onSuccess: async () =>
      queryClient.setQueryData(
        currentWorkspaceQueryKey,
        await fetchStoredCurrentWorkspace(storageHandler, storageKeys)
      ),
  });
};
